import { CheckCircle, XCircle, WarningCircle, ArrowsLeftRight, Scales } from "@phosphor-icons/react";

const DIM_STATUS = {
  pass: { label: "Pass", cls: "text-emerald-700 bg-emerald-50 border-emerald-200", Icon: CheckCircle },
  fail: { label: "Blocker", cls: "text-red-700 bg-red-50 border-red-200", Icon: XCircle },
  unknown: { label: "Unknown", cls: "text-orange-700 bg-orange-50 border-orange-200", Icon: WarningCircle },
  flex: { label: "Flex used", cls: "text-blue-700 bg-blue-50 border-blue-200", Icon: ArrowsLeftRight },
};

// Map an eligibility check (+ flex areas) to a PASS / FAIL / UNKNOWN / FLEX USED dimension status.
export function dimStatusFor(check, flexAreas) {
  if (check.status === "eligible") return flexAreas && flexAreas.has(check.title) ? "flex" : "pass";
  if (check.status === "not_eligible") return "fail";
  return "unknown";
}

export function DimStatusChip({ status }) {
  const m = DIM_STATUS[status] || DIM_STATUS.unknown;
  const Icon = m.Icon;
  return (
    <span
      data-testid={`dim-status-${status}`}
      className={`inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-[11px] font-semibold shrink-0 ${m.cls}`}
    >
      <Icon weight="fill" className="h-3 w-3" /> {m.label}
    </span>
  );
}

export function CriteriaFitCaption({ className = "" }) {
  return (
    <p data-testid="criteria-fit-caption" className={`text-xs text-slate-500 leading-relaxed ${className}`}>
      Criteria fit — <span className="font-medium text-slate-600">not a hire probability</span>. It shows how your confirmed facts line up with this role's stated criteria, nothing more.
    </p>
  );
}

export function HumanAgencyNote({ className = "" }) {
  return (
    <div
      data-testid="human-agency-note"
      className={`flex items-start gap-2 rounded-md border border-slate-200 bg-slate-50 px-3 py-2.5 ${className}`}
    >
      <Scales weight="fill" className="text-slate-400 mt-0.5 shrink-0" />
      <p className="text-xs text-slate-600 leading-relaxed">
        <span className="font-semibold text-slate-700">We recommend, you decide.</span> We surface the facts behind every
        result — what matches, what doesn't, and what's still unknown. Unknown information never counts against you, and we
        never predict whether you'll be hired.
      </p>
    </div>
  );
}
